export class StudyVersionResModel {
  VersionName: string;
  VersionNO?: number;
}
